<template>
  <div
    class="a-good-company-stage"
    :style="{
      '--bg-image-xs': `url(${bgImageXs})`,
      '--bg-image-md': `url(${bgImageMd})`,
      '--bg-image-lg': `url(${bgImageLg})`,
    }"
  >
    <GridContainer
      class="a-good-company-stage__container"
      padding
    >
      <div class="a-good-company-stage__content">
        <slot name="content" />
      </div>
      <div class="a-good-company-stage__hero">
        <slot name="hero" />
      </div>
    </GridContainer>
  </div>
</template>

<script>
import { GridContainer } from '@i22-td-smarthome/component-library';

export default {
  name: 'AGoodCompanyStage',
  props: {
    bgImageXs: { type: String, default: '' },
    bgImageMd: { type: String, default: '' },
    bgImageLg: { type: String, default: '' },
  },
  components: { GridContainer },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.a-good-company-stage {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-color: #fff;
  margin-bottom: 75px;
  height: 720px;
  background-image: var(--bg-image-xs);

  @include mq($mq-sm) {
    background-image: var(--bg-image-md);
  }
  @include mq($mq-lg) {
    background-image: var(--bg-image-lg);
  }

  &__container {
    position: relative;
    justify-content: flex-start;
    overflow: unset;
    flex-direction: column;
    @include mq($mq-sm) {
      flex-direction: row;
    }
  }
  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: $grid-base * 4 $grid-base $grid-base * 4 0;
    @include mq($mq-sm) {
      padding: $grid-base * 4 $grid-base $grid-base * 4 0;
      max-width: 50%;
    }
    @include mq($mq-lg) {
      padding: $grid-base * 4 $grid-base $grid-base * 6 0;
    }
    @include mq($mq-xl) {
      max-width: 40%;
      padding: $grid-base * 3 $grid-base $grid-base * 8 0;
    }
  }
  &__hero {
    display: flex;
    justify-content: center;
    max-width: 420px;
    transform: translateY(25px);
    @include mq($mq-sm) {
      transform: translateY(0);
      position: absolute;
      width: 50%;
      top: 0;
      height: calc(100% + 50px);
      right: 0;
      max-width: 560px;
    }
    @include mq($mq-lg) {
      max-width: 580px;
    }
    @include mq($mq-xl) {
      max-width: initial;
    }
  }
  :deep(.grid-container) {
    height: 100%;
  }
  :deep(.a-good-company__hero-update) {
    @include mq($mq-sm) {
      position: absolute;
      bottom: 0;
      left: 0;
    }
    @include mq($mq-xl) {
      bottom: auto;
      left: auto;
      top: 0;
      right: 0;
    }
  }
}
</style>
